import React from 'react'
import LeaderboardDatagrid from '../leaderboard/LeaderboardDatagrid'

const PlayerLeaderboardsWidget = ({player}) => {
  return <LeaderboardDatagrid filter={{player: player.id}} />
}

export default PlayerLeaderboardsWidget
